import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const ResponsibleAuthoritiesService = {
  responsibleAuthorities: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/responsible_authorities",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/responsible_authorities/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (responsible_authorities) {
    const requestData = {
      method: "post",
      url: "/api/management/responsible_authorities/update",
      data: responsible_authorities
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/responsible_authorities",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    console.log("REQUEST", requestData);
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default ResponsibleAuthoritiesService;

